import { AnimationDetailsDTO } from "../../../dto/AnimationDetailsDTO";
import { AnimationDTO } from "../../../dto/AnimationDTO";

export function getAnimationDisplayLabel(
  animation: Pick<AnimationDTO, "name" | "animationState"> | undefined | null
) {
  if (!animation) return "No animation selected";
  return animation.animationState || animation.name;
}

export function getAnimationStoredName(
  animation: Pick<AnimationDetailsDTO, "name"> | undefined | null
) {
  return animation?.name ?? "";
}
